export type SdkRequestConfig = {
  params?: Record<string, string | number | undefined>;
  headers?: Record<string, string>;
  responseType?: "json" | "arraybuffer" | "blob" | "text";
  data?: unknown;
};

export type CatalogQuery = {
  name?: string;
  slug?: string;
  variant?: string;
  index?: number;
  subsceneKey?: string;
};

export type SdkRequest = {
  get: (url: string, config?: SdkRequestConfig) => Promise<{ data: any }>;
  post?: (
    url: string,
    data?: unknown,
    config?: SdkRequestConfig,
  ) => Promise<{ data: any }>;
  put?: (
    url: string,
    data?: unknown,
    config?: SdkRequestConfig,
  ) => Promise<{ data: any }>;
  patch?: (
    url: string,
    data?: unknown,
    config?: SdkRequestConfig,
  ) => Promise<{ data: any }>;
  delete?: (url: string, config?: SdkRequestConfig) => Promise<{ data: any }>;
};

export type CatalogScope = {
  deviceId?: string;
};

export const requirePost = (request: SdkRequest) => {
  if (!request.post) {
    throw new Error("Request adapter is missing post()");
  }
  return request.post;
};

export const requirePut = (request: SdkRequest) => {
  if (!request.put) {
    throw new Error("Request adapter is missing put()");
  }
  return request.put;
};

export const requireDelete = (request: SdkRequest) => {
  if (!request.delete) {
    throw new Error("Request adapter is missing delete()");
  }
  return request.delete;
};
